import getRootDomain from 'common/get-root-domain';

export const ROOT_DOMAIN = getRootDomain();
export const THM_ORIGIN = 'https://thm.visa.com';
